export enum EnumGaOperation {
  UPLOAD_FILE = 'Upload-File',
  DELETE_FILE = 'Delete-File',
}

export enum EnumEstadoControl {
  ESTADO_INICIAL = -1,
  OK = 0,
  OBLIGATORIO_NO_SELECCIONADO = 1,
  SELECIONADO_NO_SUBIDO = 2
}

export enum EnumOrigenComponent {
  MEDIOS_VERIFICACION = 1,
  DOCUMENTOS_OPERACION = 2,
  VISOR_AT = 3,
  DOCUMENTOS_CONSULTA = 4,
  CAMBIO_RL = 5
}
